import { render, staticRenderFns } from "./IconAcademicCapOutline.vue?vue&type=template&id=16c46002"
import script from "./IconAcademicCapOutline.vue?vue&type=script&lang=js"
export * from "./IconAcademicCapOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports